import {
  Button as MuiButton,
  CircularProgress,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";

import nextIcon from "../../assets/images/icons/next.svg";
import { COLORS } from "../../theme/colors";
import { styles } from "../../theme/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "1.3rem",
    minWidth: 100,
  },
  label: {
    fontWeight: 600,
  },
  icon: {
    marginLeft: theme.spacing(1),
  },
  prefixIcon: {
    marginRight: theme.spacing(1),
  },
  circle: { color: COLORS.white },
  circleForTextBtn: {
    color: theme.palette.primary.main,
  },
  textButton: {
    fontWeight: 600,
    "&:hover": {
      color: COLORS.hovered_purple,
    },
  },
  smRectangleButtonActive: {
    padding: `${theme.spacing(0.2)}px ${theme.spacing(1)}px`,
    backgroundColor: theme.palette.primary.main,
    color: COLORS.white,
    borderRadius: 5,
    fontWeight: 700,
    marginRight: theme.spacing(1),
    cursor: "pointer",
  },
  smrectangleButton: {
    cursor: "pointer",
    marginRight: theme.spacing(1),
  },
  plusText: {
    fontSize: 32,
    fontWeight: "bold",
    lineHeight: "34px",
    width: 36,
    height: 34,
    borderRadius: "50%",
    border: "1px solid #D8D8D8",
    backgroundColor: COLORS.white,
    cursor: "pointer",
    "&:hover": {
      boxShadow: styles.boxShadows.customDarks[4],
    },
  },
}));

export const Button = ({
  text,
  next,
  onClick,
  rootStyle,
  loading,
  component,
  disabled,
  id,
  prefixIcon,
  href,
  variant,
  buttonStyle,
}) => {
  const classes = useStyles();
  return (
    <MuiButton
      id={id}
      className={classes.root}
      color="primary"
      variant={variant || "contained"}
      classes={{ label: classes.label, root: rootStyle }}
      onClick={onClick}
      component={component}
      disabled={disabled}
      href={href}
    >
      {loading ? (
        <CircularProgress className={classes.circle} style={buttonStyle} size="1.5rem" />
      ) : (
        <>
          {prefixIcon && <img className={classes.prefixIcon} src={prefixIcon} />}
          {text}
          {next && <img className={classes.icon} src={nextIcon} alt="next-icon" />}
        </>
      )}
    </MuiButton>
  );
};

export const TextButton = ({
  text,
  onClick,
  loading,
  icon,
  disabled,
  style,
  textStyle,
  normalFontWeight,
}) => {
  const classes = useStyles();

  return (
    <>
      {loading ? (
        <CircularProgress className={classes.circleForTextBtn} style={style} size="1.5rem" />
      ) : (
        <Grid
          container
          style={{
            width: "fit-content",
            cursor: disabled ? "default" : "pointer",
            ...style,
          }}
          onClick={disabled ? null : onClick}
          alignItems="center"
        >
          {icon}
          <Typography
            className={classes.textButton}
            align="center"
            color="primary"
            style={{
              color: disabled ? "rgba(0, 0, 0, 0.26)" : null,
              ...textStyle,
              ...(normalFontWeight && { fontWeight: 400 }),
            }}
          >
            {text}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export const SmallRectangleButton = ({ text, active, onClick }) => {
  const classes = useStyles();
  return (
    <Typography
      className={active ? classes.smRectangleButtonActive : classes.smrectangleButton}
      onClick={onClick}
    >
      {text}
    </Typography>
  );
};

export const PlusButton = ({ onClick }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.plusText} align="center" color="primary" onClick={onClick}>
      +
    </Typography>
  );
};

export const IconText = ({
  text,
  onClick,
  rootStyle,
  loading,
  component,
  disabled,
  id,
  prevIcon,
}) => {
  const classes = useStyles();

  return (
    <MuiButton
      id={id}
      className={classes.root}
      color="primary"
      variant="contained"
      classes={{ label: classes.label, root: rootStyle }}
      onClick={onClick}
      component={component}
      disabled={disabled}
    >
      {loading ? (
        <CircularProgress className={classes.circle} size="1.5rem" />
      ) : (
        <>
          {prevIcon && (
            <img
              className={classes.icon}
              src={prevIcon}
              alt="next-icon"
              style={{ marginRight: "5px" }}
            />
          )}
          {text}
        </>
      )}
    </MuiButton>
  );
};

export const ButtonWithTooltip = ({
  title,
  text,
  onClick,
  rootStyle,
  disabled,
  placement = "top",
}) => {
  const classes = useStyles();
  return (
    <Tooltip title={title} placement={placement}>
      <span>
        <MuiButton
          className={classes.root}
          color="primary"
          variant="contained"
          classes={{ label: classes.label, root: rootStyle }}
          onClick={onClick}
          disabled={disabled}
        >
          {text}
        </MuiButton>
      </span>
    </Tooltip>
  );
};
